import Grid2 from '@shared/components/Grid2';
import { H3, H4 } from '@shared/components/Heading';
import Paragraph from '@shared/components/Paragraph';
import { FC, memo } from 'react';

import { H2Gold } from '../../components/ColoredHeading';
import { SectionDark3 } from '../../components/ColoredSection';

const Schwerkraft: FC = () => (
  <SectionDark3>
    <H2Gold>Dein unsichtbarer Verbündeter</H2Gold>
    <H4 uppercase={false}>
      Oft werden wir gefragt, warum Systema so mühelos aussieht. Das kann doch gar nicht realistisch
      sein?
    </H4>
    <Grid2 spacing={{ md: '2rem', xs: '0' }}>
      <Grid2.Item>
        <H3 margin={{ top: '1.5rem' }}>Schwerkraft und Stütze</H3>
        <Paragraph>
          Im Systema arbeiten wir eng mit unserem "unsichtbaren Verbündeten" zusammen: Der
          Schwerkraft. Wir haben uns so sehr an die Schwerkraft gewöhnt, dass wir sie gar nicht mehr
          bewusst wahrnehmen. Wenn Du ganz genau in Dich hinein spürst, wirst Du bemerken, wie die
          Schwerkraft an Dir zieht, wenn Du Dich auch nur ein bisschen schief hinstellst. Deine
          Muskeln werden sich aktivieren und diesen Zug ausgleichen. Schon hast Du Dich angespannt
          und ein bisschen Bewegungsfreiheit verloren.
        </Paragraph>
        <Paragraph>
          Im Training erforschen wir die Wechselwirkung mit der Schwerkraft, lernen mühelos und
          weich zu fallen und auch mühelos wieder aufzustehen. Indem wir uns der Schwerkraft
          hingeben und bewusst die Balance verlieren, kommt unser Körper in Bewegung, fällt zu Boden
          und sucht instinktiv nach einem Halt, einer <strong>Stütze</strong>.
        </Paragraph>
        <Paragraph>
          Diese Stütze finden wir in unserem Partner. Wir halten uns an ihm fest, um unseren Sturz
          aufzuhalten. Damit <strong>beladen</strong> wir ihn mit unserem Körpergewicht. Wer kann
          schon ganz einfach einen Druck von 50-100kg mit den Armen aufbauen - mit dem Körpergewicht
          gelingt das <strong>mühelos</strong>.
        </Paragraph>
      </Grid2.Item>
      <Grid2.Item>
        <H3 margin={{ top: '1.5rem' }}>Kraft durch Entspannung</H3>
        <Paragraph>
          Wichtig ist also, dass wir nicht mit Kraft drücken, sondern uns einfach der Schwerkraft{' '}
          <strong>hingeben</strong>. Wir <strong>fallen</strong>. Je entspannter wir fallen, desto
          größer ist die Beschleunigung. Im Freien Fall wäre die Beschleunigung am höchsten, diese
          Werte erreichen wir natürlich nicht. Trotzdem nimmt die Beschleunigung zu, je weniger
          unsere Körperstruktur und -muskulatur den Fall bremst. Je <strong>entspannter</strong>,
          desto schneller.
        </Paragraph>
        <Paragraph>
          Auf den Partner, an dem wir uns festhalten (den wir "beladen"), wirkt deshalb nicht nur
          unser Körpergewicht, sondern weit mehr.
        </Paragraph>
        <Paragraph bold>Kraft = Masse * Beschleunigung.</Paragraph>
        <Paragraph margin={{ top: '2em' }}>
          Die Meisterschaft besteht nun darin, auch die kleinste Chance zum Fallen zu erkennen und
          sich ihr hinzugeben. Während der Partner seine Schieflage nicht bemerkt und sich unbewusst
          anspannt, lassen wir los und unsere beschleunigte Masse wirken.
        </Paragraph>
      </Grid2.Item>
    </Grid2>
  </SectionDark3>
);

export default memo(Schwerkraft);
